import Image from 'next/image';
import Link from 'next/link';

/**
 * Minimal header for /app — logo + tagline only, no site nav/search/login.
 * Visitors here came from an ad or a share link for one reason (get the
 * app); the full site chrome is a distraction, not a wayfinding aid.
 *
 * Deliberately NOT `.app-header` (fixed, locked to the shared
 * `--header-height: 56px`): sized larger than that slot to match the
 * mockup. This sits in normal document flow instead, sized to its own
 * content — `MobileLayout` skips the fixed-header `main` offset for this
 * page to match.
 *
 * `.safe-top` (padding-top: var(--safe-area-inset-top)) stands in for the
 * `.app-header` fixed-header class this page doesn't use, which is what
 * normally keeps page content clear of the status bar inside the native
 * app — this page needs that same inset on its own.
 *
 * `docuproHeader.png` already has the "Government Documentation
 * Simplified" tagline baked into the graphic (icon + wordmark + tagline,
 * one image) — don't add it again as a separate line, that's a visible
 * duplicate.
 */
export function AppDownloadHeader() {
  return (
    <header className="safe-top bg-background border-b">
      <div className="container flex items-center justify-center py-4 md:py-5">
        <Link href="/">
          <Image
            src="/docuproHeader.png"
            alt="DocuPro — Government Documentation Simplified"
            className="h-12 w-auto sm:h-14"
            width={512}
            height={162}
            priority
          />
        </Link>
      </div>
    </header>
  );
}
